import { createContext } from 'react';
/** Absent outside the thread footer, including Home and other AskInput consumers. */
export const ThreadSubmitDisabledContext = createContext(undefined);
//# sourceMappingURL=ThreadSubmitDisabledContext.js.map